export default "__VITE_ASSET__7f4e9632__"